import React from 'react';
export function AuroraBackground() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-2">
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-purple-900/8 blur-[120px]" data-id="element-3" />
      <div className="absolute top-[20%] right-[-5%] w-[30%] h-[30%] rounded-full bg-blue-900/8 blur-[120px]" data-id="element-4" />
      <div className="absolute bottom-[-10%] left-[20%] w-[35%] h-[35%] rounded-full bg-indigo-900/8 blur-[120px]" data-id="element-5" />
    </div>;
}